/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/canva" */ '@atlassian/logo-third-party/canva'
		).then((m) => m.CanvaIcon),
	{ moduleId: '@atlassian/logo-third-party/canva' },
);

const LazyCanvaIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-canva" */ './utils').then((m) => m.CanvaIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/canva/icon' },
);

const LazyCanvaSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-canva-search-result" */ './utils').then(
			(m) => m.CanvaSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/canva/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const CanvaIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyCanvaIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const CanvaSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyCanvaSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
